import React from 'react';

const SIZE_PX = {
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
};

// Wrapper pra ícones lucide-react. Uso:
//   import { Package } from 'lucide-react';
//   <Icon as={Package} size="sm" className="text-primary" />
// Mantém API consistente enquanto padroniza tamanhos.
const Icon = ({ as: Component, size = 'md', className = '', strokeWidth = 2, ...rest }) => {
  if (!Component) return null;
  const px = SIZE_PX[size] ?? SIZE_PX.md;
  return <Component size={px} strokeWidth={strokeWidth} className={className} {...rest} />;
};

export default Icon;
